const theme = {
  colors: {
    white: '#fff',
    black: '#000'
  }
}

export default theme;

export type CrawlerTheme = typeof theme;